module.exports = __webpack_public_path__ + "media/12a.8cd2c342.mp4";